import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase";

export default function Bills() {

const { user, loading: authLoading } = useAuth();

const [bill, setBill] = useState(null);
const [loading, setLoading] = useState(true);

useEffect(() => {

if (authLoading) return;

const load = async () => {

if (!user) {
setBill(null);
setLoading(false);
return;
}

const mobile = String(
user.mobile || user.phoneNumber || ""
)
.replace(/\D/g,'')
.slice(-10);

if (!mobile) {
setBill(null);
setLoading(false);
return;
}

try {
const ref = doc(db, "bills", mobile);
const snap = await getDoc(ref);

if (snap.exists()) {
setBill(snap.data());
} else {
setBill(null);
}
} catch (e) {
console.log("Bills error:", e);
setBill(null);
}

setLoading(false);
};

load();

}, [user, authLoading]);

/* loading */

if (authLoading || loading) {
return (
<div style={{padding:20}}>
Loading bills...
</div>
);
}

/* no bills */

if (!bill) {
return (
<div style={{padding:20}}>
No bills found
</div>
);
}

/* UI */

return (
<div style={{padding:"16px"}}>

<h2 style={{
marginBottom:12,
fontSize:18,
fontWeight:600
}}>
My Bills
</h2>

<div style={{
background:"#fff",
borderRadius:12,
padding:16,
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
border:"1px solid #eee"
}}>

<div style={row}>
<span style={label}>Customer</span>
<span style={value}>{bill.customerId}</span>
</div>

<div style={row}>
<span style={label}>Mobile</span>
<span style={value}>{bill.mobile}</span>
</div>

<div style={row}>
<span style={label}>Email</span>
<span style={value}>{bill.email}</span>
</div>

<div style={{
...row,
marginTop:8,
paddingTop:8,
borderTop:"1px solid #eee"
}}>
<span style={label}>Amount</span>
<span style={{
...value,
fontWeight:700,
color: Number(bill.amount) < 0 ? "#e53935" : "#2e7d32",
fontSize:18
}}>
₹ {bill.amount}
</span>
</div>

<a
href={bill.url}
target="_blank"
rel="noreferrer"
style={{
display:"block",
marginTop:14,
background:"#0061ff",
color:"#fff",
textAlign:"center",
padding:"10px",
borderRadius:8,
textDecoration:"none",
fontWeight:500
}}
>
View Full Bill
</a>

</div>

</div>
);
}

const row = {
display:"flex",
justifyContent:"space-between",
padding:"6px 0",
fontSize:14
};

const label = {
color:"#666"
};

const value = {
fontWeight:500,
color:"#111",
maxWidth:"60%",
textAlign:"right"
};